import React from 'react';
import PropTypes from 'prop-types';
import { Image } from './Image';
import {
  imgTkoverCont,
  imgTkoverContCopy,
  imgTkoverImage
} from './Styles/imgTakeover';
import { PhotographersLink } from './responsive/atoms/PhotographersLink';

export const ImageTakeover = ({ entity }) => {
  return (
    <div className="scrollable">
      <div css={imgTkoverImage}>
        <Image entity={entity} quality={100} />
        <div css={imgTkoverCont}>
          {entity.caption !== '' ? (
            <div
              css={imgTkoverContCopy}
              // oxlint-disable-next-line no-danger
              dangerouslySetInnerHTML={{
                __html: entity.caption
              }}
            />
          ) : undefined}
          <PhotographersLink
            photographers={entity.photographers}
            color={{ text: '#555', link: '#fff' }}
          />
        </div>
      </div>
    </div>
  );
};

ImageTakeover.propTypes = {
  entity: PropTypes.objectOf(PropTypes.any)
};
